import React from 'react';
import { Link } from 'react-router-dom';
import { 
  BookOpen, 
  Phone, 
  Mail, 
  MapPin, 
  Facebook, 
  Twitter, 
  Instagram, 
  Linkedin,
  Heart,
  Globe
} from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Register', path: '/register' },
    { name: 'Login', path: '/login' },
  ];

  const contactInfo = [
    {
      icon: Phone,
      text: '+91 73860 78298',
      link: 'tel:+917386078298'
    },
    {
      icon: Mail,
      text: 'info@quadratech.in',
      link: 'mailto:info@quadratech.in'
    },
    {
      icon: Globe,
      text: 'www.quadratechhometuitions.in',
      link: 'https://www.quadratechhometuitions.in'
    },
    {
      icon: MapPin,
      text: 'Hyderabad, Telangana, India',
      link: '#'
    }
  ];

  const socialLinks = [
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Twitter, href: '#', label: 'Twitter' },
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Linkedin, href: '#', label: 'LinkedIn' },
  ];

  return (
    <footer className="bg-slate-900 text-white font-sans mt-auto border-t-4 border-primary-500">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <div className="bg-primary-500 p-2 rounded-2xl">
                <BookOpen className="h-6 w-6 text-white" />
              </div>
              <span className="text-xl font-bold tracking-tight">Quadra Tech</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Providing expert home and online tutoring across Hyderabad. We bring quality education directly to you.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center text-slate-400 hover:bg-primary-500 hover:text-white transition-all duration-300 hover:scale-110"
                    aria-label={social.label}
                  >
                    <Icon className="h-4 w-4" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-6">Quick Links</h3>
            <ul className="space-y-4">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-slate-300 hover:text-primary-400 transition-colors duration-200 text-sm font-medium flex items-center gap-2 group"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-700 group-hover:bg-primary-400 transition-colors" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tech Services */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-6">Tech Services</h3>
            <ul className="space-y-4">
              {[
                { name: 'Web Development', path: '/contact#tech-solutions' },
                { name: 'App Development', path: '/contact#tech-solutions' },
                { name: 'UI/UX Design', path: '/contact#tech-solutions' },
                { name: 'SEO Optimization', path: '/contact#tech-solutions' }
              ].map((service, index) => (
                <li key={index}>
                  <a
                    href={service.path}
                    className="text-slate-300 hover:text-primary-400 transition-colors duration-200 text-sm font-medium flex items-center gap-2 group"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-700 group-hover:bg-primary-400 transition-colors" />
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-slate-500 mb-6">Contact Us</h3>
            <div className="space-y-4">
              {contactInfo.map((contact, index) => {
                const Icon = contact.icon;
                return (
                  <a
                    key={index}
                    href={contact.link}
                    className="flex items-start space-x-3 text-slate-300 hover:text-primary-400 transition-colors duration-200 group"
                  >
                    <div className="mt-1 p-1.5 rounded-lg bg-slate-800 group-hover:bg-primary-900/50 transition-colors">
                      <Icon className="h-4 w-4 text-slate-400 group-hover:text-primary-400" />
                    </div>
                    <span className="text-sm font-medium leading-relaxed">{contact.text}</span>
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-slate-500 text-sm font-medium">
              © {currentYear} QUADRA TECH HOME TUITIONS. All rights reserved.
            </div>
            <p className="text-slate-500 text-sm font-medium flex items-center gap-1.5 bg-slate-800/50 px-4 py-2 rounded-full">
              Made with <Heart className="h-4 w-4 text-red-500 fill-current animate-pulse" /> 
              <span>by KATKOJWAL KRISHNA</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
